import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Brand";

export function RequestsPanel({ onCount }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/institution/requests").then((r) => { setItems(r.data); onCount?.(r.data.length); });
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const decide = async (m, approve) => {
    await api.post(`/institution/requests/${m.id}/decision`, { approve });
    toast.success(approve ? `${m.user_name} aprovado(a)` : "Pedido recusado");
    load();
  };

  if (!items.length) return <p className="py-14 text-center text-muted-foreground" data-testid="requests-empty">Nenhum pedido de vínculo pendente.</p>;
  return (
    <div className="space-y-2" data-testid="requests-list">
      {items.map((m) => (
        <div key={m.id} className="flex items-center gap-3 rounded-2xl border border-white/5 bg-card p-4" data-testid={`request-item-${m.id}`}>
          <Avatar name={m.user_name} size={40} />
          <div className="min-w-0 flex-1">
            <p className="font-bold">{m.user_name} {m.user_is_minor && <span className="ml-1 rounded-full bg-amber-500/15 px-2 py-0.5 text-[10px] text-amber-300">menor</span>}</p>
            <p className="truncate text-xs text-muted-foreground">quer entrar em <span className="text-white/80">{m.room_title}</span></p>
            {m.message && <p className="mt-1 text-sm italic text-white/70">"{m.message}"</p>}
          </div>
          <button onClick={() => decide(m, true)} className="grid h-10 w-10 place-items-center rounded-full bg-emerald-600 hover:bg-emerald-500" data-testid={`request-approve-${m.id}`}><Check size={17} /></button>
          <button onClick={() => decide(m, false)} className="grid h-10 w-10 place-items-center rounded-full bg-white/10 hover:bg-red-600" data-testid={`request-reject-${m.id}`}><X size={17} /></button>
        </div>
      ))}
    </div>
  );
}
